import React from "react";
import AnnouncementBar from "../../../../components/AnnouncementBar/AnnouncementBar";
import FAQIndex from "../../../../components/SidetabPages/Configuration/Faqs/FAQIndex";

const FAQ = () => {
  return (
    <>
      <AnnouncementBar />
      <FAQIndex />
    </>
  );
};
export default FAQ;
